import { jwtDecode } from "jwt-decode";

export const formatYYYYMMDD = (str) => {
	const months = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	];
	const arr = str.split("-");
	return arr[2] + " " + months[parseInt(arr[1] - 1)] + " " + arr[0];
};

export const buildQueryParams = (params) =>
  Object.entries(params)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
	
export const decodeRolesFromToken = () => {
	const ls = localStorage.getItem("token");
	if (ls) {
		const decodedToken = jwtDecode(ls);
		const roles = decodedToken.authorities;
		return roles;
	} else {
		return [];
	}
};

export const formatServerDate = (str) => {
	const months = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	];
	const arr0 = str.split("T");
	const arr = arr0[0].split("-");
	return arr[2] + " " + months[parseInt(arr[1] - 1)] + " " + arr[0];
};

export const sleep = (m) => new Promise((r) => setTimeout(r, m));

export function formatDateTime(dateString) {
	const date = new Date(dateString);
	const day = String(date.getDate()).padStart(2, "0");
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const year = date.getFullYear();
	const hours = String(date.getHours()).padStart(2, "0");
	const minutes = String(date.getMinutes()).padStart(2, "0");
	const seconds = String(date.getSeconds()).padStart(2, "0");
	const formattedDate = `${formatServerDate(
		dateString
	)}, ${hours}:${minutes}:${seconds}`;

	return formattedDate;
}


export const formatAmountValue = (value) => {
	if (isNaN(value)) return value;
	return parseFloat(value).toLocaleString('en-US', {
	  minimumFractionDigits: 2,
	  maximumFractionDigits: 2,
	});
  };


export 	const formatTransactionType = (transactionType) => {
		if (transactionType.includes("_")) {
			return transactionType
				.split("_")
				.map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
				.join(" ");
		} else {
			return transactionType.charAt(0).toUpperCase() + transactionType.slice(1).toLowerCase();
		}
};
	
function normalizeResponse(response) {
	if (!response) {
		throw new Error("Invalid response object");
	}

	if (response.result) {
		return {
			responseDescription: response.result.responseDescription,
			responseCode: response.result.responseCode,
		};
	}

	return {
		responseDescription: response.responseDescription,
		responseCode: response.responseCode,
	};
}


export const handleApiCall = async (
	url,
	options = {},
	signal = null
) => {
	const { method = "GET", headers = {}, body = null } = options;

	const controller = new AbortController();
	const currentSignal = signal || controller.signal;

	try {
		const response = await fetch(url, {
			method,
			headers: {
				"Content-Type": "application/json",
				"X-JWT-Assertion":localStorage.getItem("token"),
				...headers,
			},
			body: body ? JSON.stringify(body) : null,
			signal: currentSignal, // Attach the signal to the request
		});
		if (response.status === 401) {
			if (localStorage.removeItem("token") === undefined) {
				window.location.replace("/login");
			}
			return null;
		}
		if (response.status === 403) {
			return {
				responseDescription:
					"You are not authorized to perform this action.",
				responseCode: 403,
				responseStatus: false,
			};
		}

		const data = await response.json();

		if (response.status === 200) {
			if (data.result.responseCode === 200) {
				return { ...data, responseStatus: true };
			}
		}

		const data1 = normalizeResponse(data);

		return { ...data1, responseStatus: false };
	} catch (error) {
		if (error.name === "AbortError") {
			return {
				responseDescription: "API request was aborted",
				responseCode: 299,
				responseStatus: false,
			};
		} else {
			console.error("API call failed:", error);
			return {
				responseDescription:
					"Something went wrong, please try again later.",
				responseCode: 500,
				responseStatus: false,
			};
		}
	}
};